export const zIndexLayers = {
  first: 10,
  second: 20,
  third: 30,
  fourth: 40,
  fifth: 50,
};
